
import Carousel from "../components/corousel";
import NosotrosSec from "../components/nosotros_section"
import "./styles.css"

function Inicio(){
    return(
       <div className="animated-background">
       
            <div className="flex flex-col items-center p-10 space-y-10">
            <Carousel>
           
           </Carousel>
            </div>
            <div>
                <NosotrosSec>

                </NosotrosSec>
            </div>

           
       </div>
           
           
           
        
    )

}

export default Inicio;